export const LegalRelationshipType = {
    InsuranceAgent: 1,
    BoundBroker: 2,
    SupplementaryInsuranceBroker: 3,
}
export type LegalRelationshipType = typeof LegalRelationshipType[keyof typeof LegalRelationshipType]

export const LegalRelationshipTypes: [LegalRelationshipType, string][] = [
    [LegalRelationshipType.InsuranceAgent, 'Pojišťovací agent'],
    [LegalRelationshipType.BoundBroker, 'Vázaný zástupce'],
    [LegalRelationshipType.SupplementaryInsuranceBroker, 'Doplňkový pojišťovací zprostředkovatel'],
]

export const getLegalRelationshipTypeName = (type: LegalRelationshipType | undefined) => {
    return type !== undefined ? LegalRelationshipTypes.find(([key]) => key === type)?.[1] : undefined
}